import firebase from "../../config/firebase";
import { toast } from "react-toastify";
import axios from "axios";

export const register = (creds, password, onSuccess = () => { }) => {
  return async (dispatch) => {
    dispatch({
      type: "ACTION_REQUEST",
    });
    var docRef = firebase
      .firestore()
      .collection("athkey")
      .doc("Xihwaw7VUvsBOlrRaw48");

    let athleteID;
    try {
      await firebase.firestore().runTransaction(async (transaction) => {
        const athKeyDoc = await transaction.get(docRef);
        if (!athKeyDoc.exists) {
          athleteID = 1000110;
          transaction.set(docRef, { athleteID: 1000111 });
        } else {
          athleteID = Math.max(athKeyDoc.data().athleteID, 1000110);
          transaction.update(docRef, { athleteID: athleteID + 1 });
        }
      });
    } catch (e) {
      console.error("Transaction failed: ", e);
      dispatch({ type: "REGISTER_FAIL" });
      dispatch({ type: "ACTION_REQUEST_END" });
      toast.error("Failed to generate a unique Athlete ID. Please try again.");
      onSuccess();
      return;
    }

    firebase
      .auth()
      .createUserWithEmailAndPassword(creds.email, password)
      .then(async (data) => {
        // Send email verification immediately after account creation
        try {
          await data.user.sendEmailVerification();
          console.log("Verification email sent successfully");
        } catch (verificationError) {
          console.error("Error sending verification email:", verificationError);
          // Don't fail registration if verification email fails
          // User can resend from verification page
          toast.warning(
            "Account created but verification email failed to send. You can resend it from the verification page."
          );
        }

        let customImgKey = firebase.firestore().collection("users").doc();

        // Guard: img must be present before attempting upload
        if (!creds.img) {
          toast.error("No photo provided. Please upload a photo and try again.");
          dispatch({ type: "REGISTER_FAIL" });
          dispatch({ type: "ACTION_REQUEST_END" });
          onSuccess();
          return;
        }

        var imgName = creds.img.name;
        let ext2 = imgName.slice(imgName.lastIndexOf("."));
        var img_name = customImgKey.id + ext2.toLowerCase();

        var imgLets = await firebase
          .storage()
          .ref("player_files/" + customImgKey.id + ext2.toLowerCase())
          .put(creds.img);
        var imgURL = await imgLets.ref.getDownloadURL();
        let newCreds = {
          paypal_email: creds.paypal_email,
          athleteID: athleteID,
          first_name: creds.name,
          last_name: creds.lastName,
          datOffBirth: creds.datOffBirth,
          email: creds.email,
          gender: creds.gender,
          phoneNumber: creds.phoneNumber,
          chatRate: Number(creds.chatRate),
          sportBadgeRate: Number(creds.sportBadgeRate),
          sport: creds.sport,
          sportLevel: creds.sportLevel,
          city: creds.college,
          state: creds.state,
          college: creds.college,
          new_institute_id: creds.new_institute_id || "",
          institute_name: creds.institute_name,
          termsAndConditions: creds.tac,
          tol: creds.tol,
          nilPolicy: creds.nilPolicy,
          samePolicy: creds.samePolicy,
          fhpPolicy: creds.fhpPolicy,
          stateLaw: creds.stateLaw,
          tax: creds.tax,
          agreement: creds.agreement,
          typicalRestrictions: creds.typicalRestrictions,
          photoInstruction: creds.photoInstruction,
          marketing: creds.marketing,
          solely: creds.solely,
          athleteAgreement: creds.athleteAgreement,
          siteAdminAgreement: creds.siteAdminAgreement,
          nilEligible: creds.nilEligible,
          selectedClause: creds.selectedClause || "",
          role: "athlete",
          player_image: {
            file_name: img_name,
            url: imgURL,
          },
          created_at: firebase.firestore.Timestamp.now(),
          lastLoggedIn: firebase.firestore.Timestamp.now(),
          whatsappZoomValue: creds.whatsappZoomValue,
          athleteCountry: creds.athleteCountry || "",
          schoolAthlete: creds.schoolAthlete,
          countryCheckbox: creds.countryCheckbox || "",
          otherCountryCheckbox: creds.otherCountryCheckbox || "",
          emailVerified: false, // Track verification status in Firestore
        };
        let emailData = {
          city: creds.college,
          state: creds.state,
          institute_name: creds.institute_name,
          sport: creds.sport,
          athleteName: creds.name + " " + creds.lastName,
          athleteId: athleteID,
        };
        if (newCreds != null) {
          firebase
            .firestore()
            .collection("users")
            .doc(data.user.uid)
            .set(newCreds)
            .then(async (res) => {
              dispatch(sendEmailSameStateAndCityFan(emailData));
              dispatch({
                type: "REGISTER_SUCCESS",
              });
              dispatch({
                type: "ACTION_REQUEST_END",
              });
              toast.success(
                "Account Created Successfully! Please verify your email to continue. Check your spam folder if you don't see it."
              );
              onSuccess();
            })
            .catch((error) => {
              dispatch({
                type: "REGISTER_FAIL",
              });
              onSuccess();
              dispatch({
                type: "ACTION_REQUEST_END",
              });
              toast.warning(error.message);
            });
        }
      })
      .catch((error) => {
        dispatch({
          type: "REGISTER_FAIL",
        });
        onSuccess();
        dispatch({
          type: "ACTION_REQUEST_END",
        });
        toast.warning(error.message);
      });
  };
};
export const registerSuccess = () => {
  return (dispatch) => {
    dispatch({
      type: "REGISTER_COMPLETE",
    });
  };
};
export const refreshAuth =
  (uid, onComplete = () => { }) =>
    async (dispatch) => {
      try {
        const doc = await firebase
          .firestore()
          .collection("users")
          .doc(uid)
          .get();

        if (doc.exists) {
          dispatch({
            type: "LOGIN_SUCCESS",
            user: { id: doc.id, a4bEmail: doc.data().a4bEmail, ...doc.data() },
            error: "",
          });
          dispatch({
            type: "LOGIN_REQUEST_END",
          });
          onComplete();
        } else {
          console.error("❌ User document not found");
          onComplete();
        }
      } catch (error) {
        console.error("❌ refreshAuth error:", error);
        onComplete();
      }
    };
export const login = (creds) => {
  return (dispatch) => {
    dispatch({
      type: "LOGIN_REQUEST",
    });
    firebase
      .auth()
      .signInWithEmailAndPassword(creds.email, creds.password)
      .then(async (data) => {
        // Reload user to get latest email verification status
        await data.user.reload();

        var docRef = firebase
          .firestore()
          .collection("users")
          .doc(data.user.uid);
        docRef.get().then((doc) => {
          if (doc.exists) {
            if (doc.data().blocked) {
              firebase.auth().signOut();
              toast.warning("You are not allowed to access this panel");
              dispatch({
                type: "LOGIN_REQUEST_END",
              });
            } else {
              if (doc.data().role == "athlete") {
                // Update Firestore emailVerified status to match Firebase Auth
                if (data.user.emailVerified !== doc.data().emailVerified) {
                  docRef.update({
                    emailVerified: data.user.emailVerified,
                  });
                }

                dispatch(refreshAuth(data.user.uid));
                docRef.update({
                  lastLoggedIn: firebase.firestore.FieldValue.serverTimestamp(),
                });
              } else {
                toast.warning("You are not allowed to access this panel");
                dispatch({
                  type: "LOGIN_REQUEST_END",
                });
              }
            }
          } else {
            toast.warning("You are not allowed to access this panel");
            dispatch({
              type: "LOGIN_REQUEST_END",
            });
          }
        });
      })
      .catch((error) => {
        dispatch({
          type: "LOGIN_FAIL",
          uid: "",
          error: error,
        });
        dispatch({
          type: "LOGIN_REQUEST_END",
        });
        toast.warning(
          "Invalid credentials. Please try again with the correct information."
        );
      });
  };
};

export const logout = () => {
  return (dispatch) => {
    firebase
      .auth()
      .signOut()
      .then((data) => {
        // Clear all local & session storage
        localStorage.clear();
        sessionStorage.clear();

        // Clear all cookies
        const cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim();
          const eqPos = cookie.indexOf("=");
          const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        }

        dispatch({
          type: "LOGOUT_SUCCESS",
          uid: "",
          user: "",
          error: "",
        });
      })
      .catch((error) => {
        dispatch({
          type: "LOGOUT_FAIL",
          uid: "",
          error: error,
        });
      });
  };
};
export const forgetpassword = (email) => {
  return (dispatch) => {
    dispatch({
      type: "ACTION_FORGET_REQUEST",
    });
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then((res) => {
        dispatch({
          type: "ACTION_FORGET_REQUEST_END",
        });
        toast.success("Recovery Email Sent");
      })
      .catch((err) => {
        dispatch({
          type: "ACTION_FORGET_REQUEST_END",
        });
        toast.warning(err.message);
      });
  };
};
export const updatePassword = (obj, onSuccess) => {
  return (dispatch) => {
    dispatch({
      type: "PASSWORD_REQUEST",
    });
    let user = firebase.auth().currentUser;
    if (user != null) {
      let creds = firebase.auth.EmailAuthProvider.credential(
        user.email,
        obj.currentPassword
      );
      user
        .reauthenticateWithCredential(creds)
        .then(async () => {
          await user.updatePassword(obj.newPassword);
          dispatch({
            type: "PASSWORD_REQUEST_END",
          });
          toast.success("Password Updated Successfully");
          onSuccess();
        })
        .catch((error) => {
          toast.warning("Current Password is Invalid");
          dispatch({
            type: "PASSWORD_REQUEST_END",
          });
        });
    } else {
      dispatch({
        type: "PASSWORD_REQUEST_END",
      });
    }
  };
};

export const updateInfo = (uid, payload, type) => async (dispatch) => {
  if (type == "profile_fields") {
    // Sanitize payload to prevent privilege escalation
    const allowedFields = ["first_name", "last_name", "bio", "gender", "dob", "phone", "country", "player_position", "height", "weight", "hobbies"];
    const sanitizedPayload = {};
    Object.keys(payload).forEach((key) => {
      if (allowedFields.includes(key)) {
        sanitizedPayload[key] = payload[key];
      }
    });

    await firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update(sanitizedPayload)
      .then(async (res) => {
        await dispatch(refreshAuth(uid));
        toast.success("Profile Updated Successfully");
        return;
      });
  } else if (type == "address") {
    await firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update({
        city: payload.city,
        college: payload.city,
        state: payload.state,
        institute_name: payload.institute_name,
        schoolAdminId: null,
      })
      .then(async (res) => {
        await dispatch(refreshAuth(uid));
        toast.success("Profile Updated Successfully");
        return;
      });
  } else if (type == "sport") {
    firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update({ sport: payload })
      .then((res) => {
        dispatch(refreshAuth(uid));
        toast.success("Profile Updated Successfully");
        return;
      });
  } else if (type == "state") {
    firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update({ state: payload })
      .then((res) => {
        dispatch(refreshAuth(uid));
        toast.success("Profile Updated Successfully");
        return;
      });
  } else if (type == "name") {
    firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update({ first_name: payload })
      .then((res) => {
        dispatch(refreshAuth(uid));
        toast.success("Profile Updated Successfully");
        return;
      });
  } else if (type == "last_name") {
    firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update({ last_name: payload })
      .then((res) => {
        dispatch(refreshAuth(uid));
        toast.success("Profile Updated Successfully");
        return;
      });
  } else if (type == "chatRate") {
    firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update({ chatRate: payload }, { merge: true })
      .then((res) => {
        dispatch(refreshAuth(uid));
        toast.success("Chat Rate Updated Successfully");
        return;
      });
  } else if (type == "sportBadgeRate") {
    firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update({ sportBadgeRate: payload }, { merge: true })
      .then((res) => {
        dispatch(refreshAuth(uid));
        toast.success("Sport Badge Rate Updated Successfully");
        return;
      });
  } else if (type == "sportLevel") {
    firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update({ sportLevel: payload })
      .then((res) => {
        dispatch(refreshAuth(uid));
        toast.success("Profile Updated Successfully");
        return;
      });
  } else if (type == "youtube") {
    firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update({ youtube_url: payload })
      .then((res) => {
        dispatch(refreshAuth(uid));
        toast.success("Profile Updated Successfully");
        return;
      });
  } else if (type == "college") {
    firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update({ college: payload })
      .then((res) => {
        dispatch(refreshAuth(uid));
        toast.success("Profile Updated Successfully");
        return;
      });
  } else if (type == "paypal_email") {
    firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update({ paypal_email: payload })
      .then((res) => {
        dispatch(refreshAuth(uid));
        toast.success("PayPal Email Updated Successfully");
      })
      .catch((error) => {
        console.error("Error updating PayPal Email: ", error);
        toast.error("Failed to update PayPal Email: " + error.message);
      });
  } else if (type == "biography") {
    firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update({ biography: payload })
      .then((res) => {
        dispatch(refreshAuth(uid));
        toast.success("Biography Updated Successfully");
      })
      .catch((error) => {
        console.error("Error updating Biography: ", error);
        toast.error("Failed to update Biography: " + error.message);
      });
  } else if (type == "teamList") {
    firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update({ promoted_teammates: payload })
      .then((res) => {
        dispatch(refreshAuth(uid));
        toast.success("Profile Updated Successfully");
        return;
      });
  } else if (type == "Qr_Url") {
    firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update({ Qr_Url: payload })
      .then((res) => {
        dispatch(refreshAuth(uid));
        toast.success("Profile Updated Successfully");
        return;
      });
  }
};

export const updateImg = (obj, uid) => {
  return async (dispatch) => {
    dispatch({
      type: "UPDATE_IMAGE",
    });
    var desertRef = await firebase
      .storage()
      .ref()
      .child(`player_files/${obj.fileName}`);
    desertRef
      .delete()
      .then(function () { })
      .catch(function (error) {
        console.error("error", error);
      });
    let customImgKey = firebase.firestore().collection("users").doc();
    var imgName = obj.image.name;
    let ext2 = imgName.slice(imgName.lastIndexOf("."));
    var img_name = customImgKey.id + ext2.toLowerCase();

    var imgLets = await firebase
      .storage()
      .ref("player_files/" + customImgKey.id + ext2.toLowerCase())
      .put(obj.image);
    var imgURL = await imgLets.ref.getDownloadURL();
    let player_image = {
      file_name: img_name,
      url: imgURL,
    };
    firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update({ player_image })
      .then((res) => {
        dispatch(refreshAuth(uid, () => { }));
        toast.success("Image Updated Successfully");
        dispatch({
          type: "UPDATE_IMAGE_END",
        });
      })
      .catch((error) => {
        toast.warning(error.message);
        dispatch({
          type: "UPDATE_IMAGE_END",
        });
      });
  };
};

export const updateQrCode = (obj, uid) => {
  return async (dispatch) => {
    dispatch({
      type: "UPDATE_QRCODE",
    });
    if (obj.fileName) {
      var desertRef = await firebase
        .storage()
        .ref()
        .child(`player_files/${obj.fileName}`);

      desertRef
        .delete()
        .then(function () { })
        .catch(function (error) {
          console.error("error", error);
        });
    }
    let customImgKey = firebase.firestore().collection("users").doc();
    var imgName = obj.qrCode.name;
    let ext2 = imgName.slice(imgName.lastIndexOf("."));
    var img_name = customImgKey.id + ext2.toLowerCase();

    var imgLets = await firebase
      .storage()
      .ref("player_files/" + customImgKey.id + ext2.toLowerCase())
      .put(obj.qrCode);
    var imgURL = await imgLets.ref.getDownloadURL();
    let qrCode = {
      file_name: img_name,
      url: imgURL,
    };
    firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update({ qrCode })
      .then((res) => {
        toast.success("QrCode Updated Successfully");
        dispatch(refreshAuth(uid, () => { }));
        dispatch({
          type: "UPDATE_QRCODE_END",
        });
      })
      .catch((error) => {
        toast.warning(error.message);
        dispatch({
          type: "UPDATE_QRCODE_END",
        });
      });
  };
};

export const updateVid = (obj, uid) => {
  return async (dispatch) => {
    dispatch({
      type: "UPDATE_VIDEO",
    });
    var desertRef = await firebase
      .storage()
      .ref()
      .child(`player_files/${obj.fileName}`);
    desertRef
      .delete()
      .then(function () { })
      .catch(function (error) {
        console.error("error", error);
      });
    let customVidKey = firebase.firestore().collection("users").doc();
    var vidName = obj.video.name;
    let ext2 = vidName.slice(vidName.lastIndexOf("."));
    var vid_name = customVidKey.id + ext2.toLowerCase();

    var vidLets = await firebase
      .storage()
      .ref("player_files/" + customVidKey.id + ext2.toLowerCase())
      .put(obj.video);
    var vidURL = await vidLets.ref.getDownloadURL();
    let player_video = {
      file_name: vid_name,
      url: vidURL,
    };
    firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update({ player_video })
      .then((res) => {
        toast.success("Video Updated Successfully");
        dispatch({
          type: "UPDATE_VIDEO_END",
        });
      })
      .catch((error) => {
        toast.warning(error.message);
        dispatch({
          type: "UPDATE_VIDEO_END",
        });
      });
  };
};

export const isUserExist =
  (email, onComplete = () => { }) =>
    async () => {
      let user = await firebase
        .firestore()
        .collection("users")
        .where("email", "==", email)
        .get();
      if (user.docs.length == 0) {
        onComplete();
      } else {
        toast.warning("This email already exist");
      }
    };

export const sendEmailSameStateAndCityFan = (obj) => () => {
  firebase
    .firestore()
    .collection("users")
    .where("state", "==", obj.state)
    .where("city", "==", obj.city)
    .where("role", "==", "fan")
    .get()
    .then(async (query) => {
      for await (let doc of query.docs) {
        const athleteResponseEmail = `Athlete ${obj.athleteName} ID# ${obj.athleteId} has registered at school ${obj.institute_name},${obj.sport},${obj.state}
  <div style="display: flex;
  justify-content: end;">
  <a href="https://fhp-fans.web.app/auth/login?redirect=/fan/search-player"  style="text-decoration: none; color: white; background-color: #2e7bf6;  padding: 5px 10px;
  border-radius: 10px;">
  See Profile
  </a>
  </div>`;
        const options = {
          to: doc.data().email,
          subject: "New Athlete In Your Favorite School/Sport",
          html: athleteResponseEmail,
        };

        axios.post(
          "https://us-central1-fans-help-players.cloudfunctions.net/app/sendUserEmail",
          options
        );
      }
    });
};
